import React from 'react';

interface PromotionReasonsNoteProps {
  message: string;
  reasons: string[];
}

/** The note of an in-dialog notice for a marked 422 that lists what it refuses: the summary, then one row per
 * offending item. */
const PromotionReasonsNote: React.FC<PromotionReasonsNoteProps> = ({ message, reasons }) => (
  <div className="flex flex-col gap-8">
    <span>{message}</span>
    {reasons.length > 0 && (
      <ul className="list-disc pl-16">
        {/* Two offenders can share a sentence (same-named items in different collections), and the list is
            fixed per response, so the index keeps the keys unique. */}
        {reasons.map((reason, index) => (
          <li key={`${index}-${reason}`}>{reason}</li>
        ))}
      </ul>
    )}
  </div>
);

export default PromotionReasonsNote;
